import { render, staticRenderFns } from "./SubscriptionBoxOrderTracking.vue?vue&type=template&id=5d62cc43&scoped=true&lang=pug&"
import script from "./SubscriptionBoxOrderTracking.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionBoxOrderTracking.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubscriptionBoxOrderTracking.vue?vue&type=style&index=0&id=5d62cc43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62cc43",
  null
  
)

export default component.exports